import { render, staticRenderFns } from "./leftHistory.vue?vue&type=template&id=54a1fe96&scoped=true&"
import script from "./leftHistory.vue?vue&type=script&lang=js&"
export * from "./leftHistory.vue?vue&type=script&lang=js&"
import style0 from "./leftHistory.vue?vue&type=style&index=0&id=54a1fe96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1fe96",
  null
  
)

export default component.exports